/* eslint-disable import/prefer-default-export */

export enum CalculsType {
  DEFINE_SECTION = 'CalculReducerActionType/DEFINE_SECTION',
  DEFINE_CALCUL = 'CalculReducerActionType/DEFINE_CALCUL',
  RESET = 'CalculReducerActionType/RESET',
  SET_VALUE = 'CalculReducerActionType/SET_VALUE',
  DO_CALCUL = 'CalculReducerActionType/DO_CALCUL',
  UPDATE_CONTEXT_VALUE = 'CalculReducerActionType/UPDATE_CONTEXT_VALUE',
  UPDATE_CONTEXT = 'CalculReducerActionType/UPDATE_CONTEXT',
  LOAD_CONTEXT = 'CalculReducerActionType/LOAD_CONTEXT',
  REPLACE_STATE = 'CalculReducerActionType/REPLACE_STATE',
  CLEAN_CUSTOM_PROJECT = 'CalculReducerActionType/CLEAN_CUSTOM_PROJECT',
  ADD_CALCUL_CUSTOM_PROJECT = 'CalculReducerActionType/ADD_CALCUL_CUSTOM_PROJECT',
  REMOVE_CALCUL_CUSTOM_PROJECT = 'CalculReducerActionType/REMOVE_CALCUL_CUSTOM_PROJECT',
  UPDATE_PROJECT_NAME = 'CalculReducerActionType/UPDATE_PROJECT_NAME',
  UPDATE_PROJECT_DESCRIPTION = 'CalculReducerActionType/UPDATE_PROJECT_DESCRIPTION',
  UPDATE_PROJECT_ADDRESS = 'CalculReducerActionType/UPDATE_PROJECT_ADDRESS',
  UPDATE_PROJECT_ADDRESS_COMPONENTS = 'CalculReducerActionType/UPDATE_PROJECT_ADDRESS_COMPONENTS',
  UPDATE_PROJECT_AVANCEMENT = 'CalculReducerActionType/UPDATE_PROJECT_AVANCEMENT',
  ADD_DOCUMENT_FOLDER = 'CalculReducerActionType/ADD_DOCUMENT_FOLDER',
  UPDATE_DOCUMENT_FOLDER = 'CalculReducerActionType/UPDATE_DOCUMENT_FOLDER',
  REMOVE_DOCUMENT_FOLDER = 'CalculReducerActionType/REMOVE_DOCUMENT_FOLDER',
  ADD_DOCUMENT = 'CalculReducerActionType/ADD_DOCUMENT',
  UPDATE_DOCUMENT = 'CalculReducerActionType/UPDATE_DOCUMENT',
  REMOVE_DOCUMENT = 'CalculReducerActionType/REMOVE_DOCUMENT'
}
